const trackSearchOpen = () => {
    const EVENT_NAME_SEARCH_OPEN = 'search_open';

    try {
    if (typeof window.dataLayer === 'undefined') {
      console.error(`${EVENT_NAME_SEARCH_OPEN} - dataLayer not available.`);
      return;
    }
  
    window.dataLayer.push({
      event: EVENT_NAME_SEARCH_OPEN
    });
  
    console.info(`✓ GTM event ${EVENT_NAME_SEARCH_OPEN} pushed to dataLayer.`);
  } catch (error) {
    console.error(`Error tracking ${EVENT_NAME_SEARCH_OPEN}:`, error);
  }
}

window.onGtmReady(function() {
  const searchInputs = document.querySelectorAll('.search__input');
  searchInputs.forEach(input => {
    input.addEventListener('click', trackSearchOpen);
  });
});
